import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const StaffService = {
  getAllIdTypes(obj) {
    return httpClient.post(endPoints.getAllIdTypes, obj);
  },
  addIdType(obj) {
    return httpClient.post(endPoints.addIdType, obj);
  },
  updateIdType(obj) {
    return httpClient.post(endPoints.updateIdType, obj);
  },
  deleteIdTypes(obj) {
    return httpClient.post(endPoints.deleteIdTypes, obj);
  },
  getAllDistrict(obj) {
    return httpClient.post(endPoints.getDistrict, obj);
  },
  getBanks(obj) {
    return httpClient.post(endPoints.getBanks, obj);
  },
  getAllMaritalStatus(obj) {
    return httpClient.post(endPoints.getMaritalStatus, obj);
  },
  addMaritalStatus(obj) {
    return httpClient.post(endPoints.addMaritalStatus, obj);
  },
  deleteMaritalStatus(obj) {
    return httpClient.post(endPoints.deleteMaritalStatus, obj);
  },
  updateMaritalStatus(obj) {
    return httpClient.post(endPoints.updateMaritalStatus, obj);
  },
  getAllRelationship(obj) {
    return httpClient.post(endPoints.getRelationship, obj);
  },
  addRelationship(obj) {
    return httpClient.post(endPoints.addRelationship, obj);
  },
  updateRelationship(obj) {
    return httpClient.post(endPoints.updateRelationship, obj);
  },
  deleteRelationship(obj) {
    return httpClient.post(endPoints.deleteRelationship, obj);
  },
  getAllStaff(obj) {
    return httpClient.post(endPoints.getAllStaffList, obj);
  },
  getStaff(obj) {
    return httpClient.post(endPoints.getStaff, obj);
  },
  getAllCompany(obj) {
    return httpClient.post(endPoints.getCompany, obj);
  },
  getByCompanCode(obj) {
    return httpClient.post(endPoints.getByCompanCode, obj);
  },
  getStaffByNameMobileKeyWordsAndDob(obj) {
    return httpClient.post(endPoints.getStaffByNameMobileKeyWordsAndDob, obj);
  },
  getStaffByNameMobileEmailAndDob(obj) {
    return httpClient.post(endPoints.getStaffByNameMobileEmailAndDob, obj);
  },
  getStaffDetail(obj) {
    return httpClient.post(endPoints.getStaffDetail, obj);
  },
  getStaffLists(obj) {
    return httpClient.post(endPoints.getStaffLists, obj);
  },
  getBenefits(obj) {
    return httpClient.post(endPoints.getBenefits, obj);
  },
  getAllAcademics(obj) {
    return httpClient.post(endPoints.getAllAcademics, obj);
  },
  getStaffType(obj) {
    return httpClient.post(endPoints.getStaffType, obj);
  },
  printStaff(obj) {
    return httpClient.post(endPoints.printStaff, obj);
  },
  addStaff(obj) {
    return httpClient.post(endPoints.addStaff, obj);
  },
  updateStaff(obj) {
    return httpClient.post(endPoints.updateStaff, obj);
  },
  deleteStaff(obj) {
    return httpClient.post(endPoints.deleteStaff, obj);
  },
  getStaffLeaveBal(obj) {
    return httpClient.post(endPoints.getStaffLeaveBal, obj);
  },
  getStaffListOnDuty(obj) {
    // get Staff Datas By LastWork Date
    return httpClient.post(endPoints.getStaffListOnDuty, obj);
  },
  getStaffTrace(obj) {
    // get Staff Datas By LastWork Date
    return httpClient.post(endPoints.getStaffTrace, obj);
  }
};

export default StaffService;



// WEBPACK FOOTER //
// ./src/service/StaffService.js